/* ===========================================================
   lib/api.js — talking to the Worker

   Every call carries X-Requested-With (the Worker refuses calls
   without it: that's the cross-site protection). Errors come back as
   HttpError with the server's own plain sentence when it sent one,
   so Proto can show it as-is.
   =========================================================== */

export class HttpError extends Error {
  constructor(message, status = 0, data = {}) {
    super(message);
    this.status = status;
    this.data = data;
    this.offline = status === 0;
  }
}

export async function api(path, { method = 'GET', body, raw, type, signal } = {}) {
  const headers = { 'X-Requested-With': 'docs-protocol' };
  let payload;
  if (raw !== undefined) {
    payload = raw;
    headers['Content-Type'] = type || 'application/octet-stream';
  } else if (body !== undefined) {
    payload = JSON.stringify(body);
    headers['Content-Type'] = 'application/json';
  }
  let res;
  try {
    res = await fetch(path, { method, headers, body: payload, credentials: 'same-origin', signal });
  } catch (err) {
    if (err?.name === 'AbortError') throw err;
    throw new HttpError('Failed to fetch', 0, { offline: true });
  }
  const ct = res.headers.get('Content-Type') || '';
  if (!res.ok) {
    const data = ct.includes('json') ? await res.json().catch(() => ({})) : {};
    throw new HttpError(data.error || `HTTP ${res.status}`, res.status, data);
  }
  if (ct.includes('json')) return res.json();
  return new Uint8Array(await res.arrayBuffer());
}

export const isOffline = err => err instanceof HttpError && err.offline;
